import * as React from 'react';
import * as Modal from 'react-modal';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {configEditorDispatchToPropsObject as dispatchToPropsObject} from '../../store';
import {Icon, DeployFailure} from '../util';

interface StateProps {
	loadResult: ConfigEditor.DeployResponse;
}

interface DispatchProps {
	openLogFile(): void;
	clearLoadResult(): void;
}

function mapStateToProps(state: StudioState): StateProps {
	return {
		loadResult: state.configEditor.assets.result,
	};
}

function mapDispatchToProps(dispatch: Dispatch<StudioState>): DispatchProps {
	const {openLogFile, clearLoadResult} = dispatchToPropsObject;
	return {
		openLogFile: () => dispatch(openLogFile()),
		clearLoadResult: () => dispatch(clearLoadResult()),
	};
}

type AssetLoadFailureModalProps = StateProps & DispatchProps;

class AssetLoadFailureModal extends React.Component<AssetLoadFailureModalProps, {}> {

	public render() {
		return <Modal
			isOpen={this.isOpen()}
			onRequestClose={this.props.clearLoadResult}
			contentLabel='asset-load-failure'
		>
			<a className='close-button' onClick={this.props.clearLoadResult}>
				<Icon name='close' />
			</a>
			<p className='center failure'>
				<Icon name='times-circle' size='5x' />
			</p>
			<p className='center'>
				There were errors deploying your configuration.
			</p>
			<div className='deploy-response'>
				<DeployFailure deployResponse={this.props.loadResult} />
			</div>
		</Modal>;
	}

	private isOpen() {
		return (this.props.loadResult && !this.props.loadResult.success) || false;
	}

}

export default connect<StateProps, DispatchProps, {}>
	(mapStateToProps, mapDispatchToProps)(AssetLoadFailureModal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/AssetLoadFailureModal.tsx